// extracted by mini-css-extract-plugin
export default {"chevron":"Editor_chevron__gpPXL","problem":"Editor_problem__l7uw5"};